module.exports = __webpack_public_path__ + "static/media/lov.21bec9cf.mp3";